$(document).ready(function () {
    let $cookieContainer = $('.js-cookie-modal-container');

    if ($cookieContainer.attr('data-can-open') === 'true') {
        $cookieContainer.addClass('open');
        $('body').addClass('open');
        window.trapKeyboardFocus('#js-cookie-banner-modal');
    }
});

$(document).on('click', '.js-cookie-details', function (event) {
    event.preventDefault();

    let $cookieBarContainer = $('.js-cookie-sidebar');
    $cookieBarContainer.removeClass('d-none');
    $('.js-cookie-modal-container').addClass('show-sidebar');
    $('.cookie-modal-overlay').css('z-index', 100);


    // when banner is triggered & open, trap focus within for keyboard users (accessibility)
    $cookieBarContainer.toggleClass('open');
    if ($cookieBarContainer.hasClass('open')) {

        $cookieBarContainer.removeAttr('aria-hidden');
        // set modal content exposed to accessibility tree
        $('.js-close-banner').attr('tabindex', '0').removeAttr('aria-hidden');
        $('.js-banner-item').attr('tabindex', '0').removeAttr('aria-hidden');
        window.trapKeyboardFocus('#js-cookie-banner-sidebar');
    } else {
        $cookieBarContainer.find('.js-banner-item').attr('tabindex', '-1').attr('aria-hidden', true);
        $cookieBarContainer.attr('aria-hidden', true);
        if (screen.width >= 768) {
            document.getElementById("js-scrolledfocusdesktop").focus();
        } else {
            document.getElementById("js-scrolled-focus-mobile").focus();
        }
    }
});

$(document).on('click', '.js-cookie-details-close', function (event) {
    event.preventDefault();

    $('.js-cookie-sidebar').addClass('d-none');
    $('.js-cookie-modal-container').removeClass('show-sidebar');
});

$(document).on('click', '.js-cookie-sidebar-toggle', function (event) {
    event.preventDefault();

    let $this = $(this);

    let value = $this.attr('data-value');

    if (value === '0') {
        $this.removeClass('toggle-off');
        $this.addClass('toggle-on');
        $this.attr('data-value', 1);
    } else {
        $this.addClass('toggle-off');
        $this.removeClass('toggle-on');
        $this.attr('data-value', 0);
    }
});

$(document).on('click', '.cookie-sidebar-toggle', function () {
    let state = $(this).attr('aria-checked');
    let isState = (state === 'true');
    $(this).attr('aria-checked', !isState);
    $(this).attr('data-value', !isState ? 1 : 0);
});

// change the state of switch checkbox in sidebar on press enter, left or right
$(document).on('keyup', '.cookie-sidebar-toggle', function (e) {
    if ((e.keyCode ? e.keyCode : e.which) === 13 || (e.keyCode ? e.keyCode : e.which) === 37 || (e.keyCode ? e.keyCode : e.which) === 39) {
        $(this).trigger('click');
    }
});

$(document).on('click', '.js-cookie-accept-all', function (event) {
    event.preventDefault();

    $.ajax({
        method: 'get',
        url: $('.js-cookie-url').attr('data-url'),
        dataType: 'json',
        data: {all: 'true'},
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
        success: function () {
            $('.js-cookie-sidebar').addClass('d-none');
            $('.js-cookie-modal-container').removeClass('open');
            $('body').removeClass('open');
            $('.js-accessible-logo').find('a').focus();
        },
    });
});

$(document).on('click', '.js-cookie-save', function (event) {
    event.preventDefault();

    $.ajax({
        method: 'get',
        url: $('.js-cookie-url').attr('data-url'),
        dataType: 'json',
        data: {
            strictly_necessary: $('.js-cookie-sidebar-toggle[data-category="strictly_necessary"][data-value="1"]').length > 0 ? 'enabled' : 'disabled',
            first_party_performance: $('.js-cookie-sidebar-toggle[data-category="first_party_performance"][data-value="1"]').length > 0 ? 'enabled' : 'disabled',
            third_party_performance: $('.js-cookie-sidebar-toggle[data-category="third_party_performance"][data-value="1"]').length > 0 ? 'enabled' : 'disabled',
            functional: $('.js-cookie-sidebar-toggle[data-category="functional"][data-value="1"]').length > 0 ? 'enabled' : 'disabled',
            targeting: $('.js-cookie-sidebar-toggle[data-category="targeting"][data-value="1"]').length > 0 ? 'enabled' : 'disabled',
        },
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
        success: function () {
            $('.js-cookie-sidebar').addClass('d-none');
            $('.js-cookie-modal-container').removeClass('open');
            $('body').removeClass('open');
            $('.js-accessible-logo').find('a').focus();
        },
    });
});

$(document).on('click', '.js-cookie-reject', function (event) {
    event.preventDefault();

    $.ajax({
        method: 'get',
        url: $('.js-cookie-url').attr('data-url'),
        dataType: 'json',
        data: {
            strictly_necessary: 'disabled',
            first_party_performance: 'disabled',
            third_party_performance: 'disabled',
            functional: 'disabled',
            targeting: 'disabled',
        },
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
        success: function () {
            $('.js-cookie-sidebar').addClass('d-none');
            $('.js-cookie-modal-container').removeClass('open');
            $('body').removeClass('open');
            $('.js-accessible-logo').find('a').focus();
        },
    });
});

$(document).on('click', '.js-toggle-cookie-banner', function (event) {
    event.preventDefault();
    $('.js-cookie-modal-container').addClass('open');

    if ($('.js-cookie-sidebar').hasClass("d-none")) {
        $('.cookie-modal-overlay').css('z-index', 90);
    }
});

function toggleActive(elem, button) {
    if (elem.classList.contains('active')) {
        elem.classList.remove('active');
        button.ariaExpanded = false;
    } else {
        elem.classList.add('active');
        button.ariaExpanded = true;
    }
}

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ck-accordion-wrapper').forEach(elem => {
        let header = elem.querySelector('.ck-accordion-trigger');
        let chevron = elem.querySelector('.ck-accordion-header-chevron');
        let description = elem.querySelector('.ck-accordion-header-desc');
        let button = elem.querySelector('.ck-accordion-trigger');

        header.addEventListener('click', () => toggleActive(elem, button));
        chevron.addEventListener('click', () => toggleActive(elem, button));
        description.addEventListener('click', () => toggleActive(elem, button));
    });
});
